import { DocumentActionTypes } from './document.types'

//Add Document
export const addDocumentRequest = data => ({
    type: DocumentActionTypes.ADD_DOCUMENT_REQUEST,
    payload: data
})

export const addDocumentRequestSuccess = data => ({
    type: DocumentActionTypes.ADD_DOCUMENT_REQUEST_SUCCESS,
    payload: data
})

export const addDocumentRequestError = data => ({
    type: DocumentActionTypes.ADD_DOCUMENT_REQUEST_ERROR,
    payload: data
})

export const addDocumentRequestStatus = data => ({
    type: DocumentActionTypes.ADD_DOCUMENT_REQUEST_STATUS,
    payload: data
})

//Document List
export const documentListRequest = data => ({
    type: DocumentActionTypes.DOCUMENT_LIST_REQUEST,
    payload: data
})

export const documentListRequestSuccess = data => ({
    type: DocumentActionTypes.DOCUMENT_LIST_REQUEST_SUCCESS,
    payload: data
})

export const documentListRequestError = data => ({
    type: DocumentActionTypes.DOCUMENT_LIST_REQUEST_ERROR,
    payload: data
})

//Document Detail
export const documentDetailRequest = data => ({
    type: DocumentActionTypes.DOCUMENT_DETAIL_REQUEST,
    payload: data
})

export const documentDetailRequestSuccess = data => ({
    type: DocumentActionTypes.DOCUMENT_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const documentDetailRequestError = data => ({
    type: DocumentActionTypes.DOCUMENT_DETAIL_REQUEST_ERROR,
    payload: data
})